$(function() {
  const $carousel = $('.carousel-customer-dashboard');

  $carousel.on('slide.bs.carousel', function(e) {
    $carousel.addClass('carousel-customer-dashboard-sliding');
  });

  $carousel.on('slid.bs.carousel', function(e) {
    $carousel.removeClass('carousel-customer-dashboard-sliding');
  })
});